import * as S from "./style";

const ResaleBanner = () => {
  return (
    <S.BannerRoot>
      <S.BannerInner>
        <S.BannerText>Resale Your Luxury</S.BannerText>
      </S.BannerInner>
    </S.BannerRoot>
  );
};

export default ResaleBanner;
